<kendo-splitter class="padding">
    <kendo-splitter-pane class="style-splitter" size="62%">
        <div style="height:100%;width: 102%;">
            <kendo-grid class="k-grid k-grid-header custom2" style="height:100%;" [kendoGridBinding]="displayObjects"
                kendoGridSelectBy="id" [(selectedKeys)]="selection" [selectable]="{ mode: 'single'}" [loading]="loading"
                [sortable]="true" [size]="smallSize" [resizable]="true" (cellClick)="onCellClick($event)"
                scrollable="virtual" [pageSize]="pageSize" [rowHeight]="15" [filterable]="false"
                (excelExport)="exportAll($event)" [rowClass]="rowCallback">
                <ng-template kendoGridToolbarTemplate>
                    <input type="text" class="kendo-like-input" placeholder="Search in Order No, Description or Company"
                        [value]="searchTerm" [(ngModel)]="searchTerm" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFilter($event)"
                        kendoGridToolbarFocusable />
                    <kendo-grid-spacer></kendo-grid-spacer>
                    <button kendoGridExcelCommand class="allbuttons" [svgIcon]="excelSVG">
                        Export
                    </button>
                </ng-template>
                <kendo-grid-column field="id" title="ID" [width]="45"></kendo-grid-column>
                <kendo-grid-column field="name" title="Order No" [width]="138"></kendo-grid-column>
                <kendo-grid-column field="description" title="Order Description" [width]="200"></kendo-grid-column>
                <kendo-grid-column field="companyName" title="Company" [width]="182"></kendo-grid-column>
                <kendo-grid-excel [fileName]="getFileName()"></kendo-grid-excel>
            </kendo-grid>
        </div>

    </kendo-splitter-pane>
    <kendo-splitter-pane>

        <form class="k-form k-form-md" [formGroup]="form">
            <div style="width:350px;">
                <button class="adminbutton allbuttons" kendoButton (click)="onAddButtonClick()"
                    [disabled]="addbuttonstate" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[0]" style="margin-right: 1px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Add</div>
                    </div>
                </button>
                <button class="adminbutton allbuttons" style="margin-left: 10px;" kendoButton
                    (click)="onRemoveButtonClick()" [disabled]="removebuttonstate" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[1]" style="margin-right: 1px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Remove</div>
                    </div>
                </button>
                <button class="adminbutton allbuttons" style="margin-left: 10px;" kendoButton
                    (click)="onSaveButtonClick()" [disabled]="savebuttonstate" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[2]" style="margin-right: 2px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Save</div>
                    </div>
                </button>
                <!-- style="right: 0; margin-left: 100px;" -->
                <button class="adminbutton allbuttons" style="margin-left: 10px;" kendoButton (click)="onUploadClick()"
                    [disabled]="uploadbuttonstate" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[3]" style="margin-right: 2px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Upload</div>
                    </div>
                </button>

            </div>


            <div class="wrap">
                <kendo-formfield>
                    <kendo-label class="label" #id id="id" [for]="id" text="ID"></kendo-label>
                    <kendo-textbox [style.width.px]="90" class="readonly" formControlName="id"
                        [readonly]="true"></kendo-textbox>
                </kendo-formfield>
                 <kendo-formfield>
                        <kendo-checkbox style="margin-left:20px;" #enabled formControlName="enabled"
                            (change)="orderEnabledChange($event)"></kendo-checkbox>
                        <kendo-label class="label" [for]="enabled" text="Enabled"></kendo-label>
                </kendo-formfield>

            </div>
            <div class="wrap">
                <kendo-formfield>
                    <kendo-label class="label" #name id="name" [for]="name" text="Name"></kendo-label>
                    <kendo-textbox [style.width.px]="300" #nametext class="class-id" formControlName="name"
                        [readonly]="readonly" (valueChange)="nameChange()"></kendo-textbox>
                </kendo-formfield>
            </div>
            <kendo-formfield>
                <kendo-label class="label" #description id="description" [for]="description"
                    text="Description"></kendo-label>
                <kendo-textbox [style.width.px]="300" #description class="class-id" formControlName="description"
                    [readonly]="readonly" (valueChange)="valueChange($event)"></kendo-textbox>
            </kendo-formfield>
            <kendo-formfield>
                <kendo-label class="label" #company id="company" [for]="company" text="Company"></kendo-label>
                <kendo-dropdownlist #company [data]="companiesItems" textField="text" valueField="value"
                    formControlName="company" [value]="selectedCompanyItem" (valueChange)="companyChange($event)"
                    [defaultItem]="companiesDefault" [style.width.px]="300">
                </kendo-dropdownlist>
            </kendo-formfield>
            <kendo-formfield>
                <kendo-label class="label" #objectType id="objectType" [for]="objectType" text="Type"></kendo-label>
                <kendo-textbox [style.width.px]="300" class="readonly" #objectType formControlName="objectType"
                    [readonly]="true" (valueChange)="valueChange($event)"></kendo-textbox>
            </kendo-formfield>

        </form>
    </kendo-splitter-pane>
</kendo-splitter>

<div>
    <kendo-window title={{windowTitle}} *ngIf="openedexcelwindow" (close)="closeExcelWindow()" [width]="550"
        [height]="400" [resizable]="false" [top]="20" [left]="30">
        <br>
        <div id="spreadsheet">
            <kendo-spreadsheet [sheets]="exceldata" #spreadsheet style="height: 260px; width: 100%" [rowHeight]="20"
                [headerHeight]="10" [columns]="3" [menuItems]="items" (excelExport)="onExcelExport($event)">
            </kendo-spreadsheet>
        </div>
        <div class="k-actions k-actions-end">
            <button kendoButton class="blue" class="allbuttons" type="button"
                (click)="closeExcelWindow()">Cancel</button>

            <button kendoButton class="blue" class="allbuttons" type="button"
                (click)="saveExcelSample(spreadsheet)">Validate</button>
        </div>
        <div class="k-dialog-content">
            <ng-container kendoDialogContainer></ng-container>
        </div>
    </kendo-window>
    <!-- <kendo-window title="Error(s) - Objects Upload" *ngIf="error?.length != 0 && error" (close)="closeExcelWindow()"
        [width]="450" [height]="200" [resizable]="true" [top]="20" [left]="30">
        <br>
        <kendo-dialog-actions style="height: 60px">{{error}}</kendo-dialog-actions>

        <kendo-dialog-actions>
            <button kendoButton style="height: 30px" (click)="closeExcelWindow()">Cancel</button>
        </kendo-dialog-actions>
    
    </kendo-window> -->



</div>

<kendo-dialog *ngIf="showErrorDialog" (close)="showErrorDialog = false">
    <kendo-dialog-titlebar>
        Error
    </kendo-dialog-titlebar>
    <p>{{ errorMessage }}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="showErrorDialog = false">OK</button>
    </kendo-dialog-actions>
</kendo-dialog>
<kendo-window [title]="title" *ngIf="errorWindow" [width]="500" [height]="250" [top]="20" [draggable]="true"
    [resizable]="true" (close)="errorWindow = false">
    <div class="error-dialog-content">
        <div class="error-text-container">
            <pre class="error-text-block">{{ content }}</pre>
        </div>
        <kendo-dialog-actions>
            <button kendoButton style="height: 30px;background-color: #1825aa;color: white"
                (click)="copyToClipboard();success('Ready to paste in Excel')">Copy for Excel</button>
            <button kendoButton style="height: 30px;background-color: #1825aa;color: white"
                (click)="errorWindow = false">Cancel</button>
        </kendo-dialog-actions>
    </div>
</kendo-window>